<template>
  <div class="nav">
    <!-- <CommonTabVue/> -->
    <div class="nav_user">
      <!-- 头像 -->
      <el-dropdown>
        <span class="el-dropdown-link">
          <img
            :src="'https://sso.chci.cn' + pic"
            alt=""
            style="width: 30px; height: 30px; border-radius: 50%"
          />
         <span style="font-size:14px;color:#262626;font-weight:400;margin:0 5px">{{userName}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="showDiag">
          <i class="el-icon-switch-button"></i>
          退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <Dialog ref="dialogs" title="确定退出登录?"  @confirms="logout"/>
  </div>
</template>

<script>
// import CommonTabVue from "./CommonTab.vue";
import Dialog from '../components/dialog.vue'
export default {
  name: "globalNav",
  data() {
    return {
      userName: $cookies.get("username") || "",
      SSOID: $cookies.get("SSOID") || "",
      pic: this.$store.state.userinfo.user.headpic||"",
    };
  },
  components:{
    // CommonTabVue,
    Dialog
  },
  methods: {
    showDiag(){
      this.$refs.dialogs.show()
    },
    // 退出登录
    logout() {
      let that = this;
      //处理vueX
      that.$store.state.isLogin = false;
      that.$store.state.SSOID = "";
      that.$store.state.userinfo = {};
      that.$store.state.userName = "";
      that.$store.state.cookie = "";
      that.$store.commit("closeAllTab")
      that.$store.commit("loginOnce",false)
      this.$.ajax({
        //备用请求 和下面的vue-jsop实际效果是一样的  只不过这个是jq
        url: "https://sso.chci.cn/jsonLogout.do?SSOID="+ $cookies.get("SSOID"),
        type: "GET",
        dataType: "jsonp",
        jsonp: "mycallback",
        xhrFields: {
          withCredentials: true, //解决跨服务传递时不传递cookie的问题，允许携带证书
        },
        crossDomain: true, //允许跨域
        timeout: 5000,
        success: function (data) {
          that.$cookies
            .keys()
            .forEach((cookie) => that.$cookies.remove(cookie));
          that.$cookies.remove("SSOID", "/", ".chci.cn");
          that.$cookies.remove("JSESSIONID", "/", ".chci.cn");
          that.$cookies.remove("isLogin", "/", ".chci.cn");
          that.isLogin = false; //当前页登录状态改为 未登录
          let returnUrl = encodeURIComponent(window.location.href);
          window.location.href =
            "https://sso.chci.cn/login.do?method=get&returnURL=" + returnUrl;
        },
      });
    },
    handleClick() {},
  },
  props: {
    // 公共面包屑
    breadcrumbList: {
      type: Array,
    },
  },
  mounted() {
  },
  beforeDestroy(){
  }
};
</script>

<style lang="scss" scoped>
.no_notice{
  text-align: center;
}
::v-deep .el-tabs__nav-scroll{
  display: flex;
  justify-content: center;
}
.notice_ul::-webkit-scrollbar {
  width: 3px;
  height: 148px;
  background: #dce3f2;
}
.notice_ul {
  max-height: 390px;
  li {
    margin-bottom: 24px;
    .notice_p {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 22px;
      color: #222222;
      margin-bottom: 10px;
      white-space: wrap;
    }
    .notice_time {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 0px;
      color: #999999;
    }
  }
}
::v-deep .stock_tabs {
  padding-left: 14px;
}
.afterSale_ul::-webkit-scrollbar {
  width: 3px;
  height: 148px;
  background: #dce3f2;
}
.afterSale_ul {
  max-height: 390px;
  li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 62px;
    margin-bottom: 24px;
    .li_txt {
      width: calc(100% - 46px);
      height: 62px;
      .time {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 0px;
        color: #999999;
        width: 100%;
        margin-top: 12px;
      }
      .txt {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 18px;
        color: #999999;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        white-space: nowrap;
        margin-top: 6px;
      }
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        height: 15px;
        .title_io {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 0px;
          color: #222222;
        }
        .title_it {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 0px;
          color: #525252;
        }
      }
    }
    .li_img {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 14px;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
  }
}
.warning_ul::-webkit-scrollbar {
  width: 3px;
  height: 148px;
  background: #dce3f2;
}
.warning_ul {
  max-height: 390px;
  overflow: auto;
  .yj {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 24px;
    .li_num {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 0px;
      color: #f83030;
    }
    .li_txt {
      width: 300px;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-around;
      .p1 {
        width: 280px;
        height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 15px;
        color: #222222;
        // margin-bottom: 12px;
      }
      .p2 {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 0px;
        color: #999999;
        width: 250px;
        height: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        white-space: nowrap;
        line-height: 12px;
      }
    }
    .li_img {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 14px;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
  }
  .notices{
    margin-bottom: 24px;
    .notice_p {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 22px;
      color: #222222;
      margin-bottom: 10px;
      white-space: wrap;
    }
    .notice_time {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 0px;
      color: #999999;
    }
  }
}
::v-deep .drop_list {
  width: 100%;
  .el-tabs__item {
    width: 33.3%;
  }
}
::v-deep .isBlack {
  .el-breadcrumb__inner {
    color: #000;
  }
}
.el-dropdown-link {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-dropdown {
  margin-left: 26px;
  cursor: pointer;
}
.nav {
  width: calc(100% - 40px);
  height: 63px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
  flex-shrink: 0;
  .nav_user {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .bell_img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 50px;
        height: 30px;
      }
    }
  }
}
</style>